var exports = {
  "W": "x4c3adb35--9516ba--dropdown",
};

module.exports = exports;
